import { render, staticRenderFns } from "./ConfigurationListing.vue?vue&type=template&id=65b6c3af&scoped=true&"
import script from "./ConfigurationListing.vue?vue&type=script&lang=js&"
export * from "./ConfigurationListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6c3af",
  null
  
)

export default component.exports